<template>
  
  <div>
  <header><h1>Digital-Bonsai</h1></header>
  <main>
  Hello {{ value }} 
  </main>
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      value: "World",
      version: "0.0.1"
    };
  }
};
</script>
